<app-expandable-section-box
  [title]="'Related Articles'"
  [iconClass]="'icon-pause'"
  [isExpandable]="isExpandable"
  [isExpandedByDefault]="isExpandedByDefault"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <div class="w-full">
      <mat-checkbox class="text-xs" [formControl]="onlySelectedEditionsControl">
        Only selected editions
      </mat-checkbox>
      <mat-form-field appearance="outline" class="flex flex-col flex-1 w-full">
        <input
          matInput
          [formControl]="searchBarControl"
          [name]="'search'"
          [placeholder]="'Search for an article'"
        />
        <button
          *ngIf="searchBarControl.value"
          mat-icon-button
          matSuffix
          (click)="clearSearch()"
        >
          <mat-icon matSuffix>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="flex flex-1 w-full">
      <mat-form-field class="w-full my-1" appearance="outline">
        <input
          matInput
          [formControl]="addArticleByUrlControl"
          [name]="'addByUrl'"
          [placeholder]="'Add article by URL'"
        />
        <button mat-icon-button matSuffix (click)="addArticleByUrl()">
          <mat-icon matSuffix>add</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="flex items-center pb-4 gap-x-2" *ngIf="isSearching">
      <mat-spinner [diameter]="12"></mat-spinner>
      <span>Searching</span>
    </div>
    <div
      *ngIf="searchList && searchList.length && !isSearching; else noData"
      class="mb-2 space-y-1 overflow-y-auto divide-y bg-project-2500 h-80 divide-project-600"
    >
      <div
        *ngFor="let search of searchList"
        class="p-1 cursor-pointer"
        (click)="handleArticleSelected(search)"
      >
        <p class="text-xxs text-project-2400">
          {{ search.publishedDate | formatDateOnlyPipe }}
        </p>
        <p
          [value]="search"
          class="text-xs break-normal"
          data-testid="searchResultTitle"
        >
          {{ search.title }}
        </p>
      </div>
      <button
        *ngIf="!isLoadingMore && hasMoreResults"
        mat-raised-button
        class="w-full h-8 my-1 text-xs font-semibold bg-project-200 text-project-500"
        (click)="loadMore(); $event.stopPropagation()"
      >
        Load More<i class="mx-2 icon icon-repeat"></i>
      </button>
      <div
        *ngIf="isLoadingMore"
        class="flex items-center justify-center w-full pb-4 text-xs gap-x-2 text-project-2100"
      >
        <span>Loading more</span>
        <mat-spinner [diameter]="12"></mat-spinner>
      </div>
    </div>
    <ng-template #noData>
      <mat-option *ngIf="!!searchBarControl.value && !isSearching" disabled>
        No results
      </mat-option>
    </ng-template>
    <div class="py-1" *ngFor="let item of relatedContents.controls">
      <app-related-articles-item
        [relatedArticle]="item"
        (handleRemove)="onRemove($event)"
        (handleInfoClick)="onInfoClick($event)"
        (handleAddToBody)="onAddToBody($event)"
      ></app-related-articles-item>
    </div>
  </div>
  <div class="flex flex-col w-full" data-testid="preview" notExpandedContent>
    <div *ngIf="relatedContents.value.length > 0" class="py-4 pb-4 pr-3 m-0">
      <ng-container *ngFor="let article of relatedContents.value">
        <p class="py-px text-xs text-project-2400">{{ article.title }}</p>
      </ng-container>
    </div>
  </div>
</app-expandable-section-box>
